import React,{useState, useEffect} from 'react';
import axios from 'axios';
import {useNavigate, Link, redirect, useParams} from "react-router-dom";
import CurrencyInput from 'react-currency-input-field';
import PacmanLoader from "react-spinners/PacmanLoader";
import { toast } from 'react-toastify';
import ReactToPrint from "react-to-print";
import MaterialReactTable from 'material-react-table';
import FormCetak from "./FormCetak";
import jwt_decode from "jwt-decode";
import { handleExportClick } from "./exportUtils";
import { handleExportClickOld } from "./exportUtilsOld";

const stylespinner = {
    position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"
  }

const DetailDebitur = () => {
    const navigate = useNavigate();
    const {idDebitur} = useParams();
    const currentDate = new Date();
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    // const formattedDate = currentDate.toLocaleDateString('id-ID', options);
    const [idUser, setIdUser] = useState("");
    const [namaLengkapUser, setNamaLengkapUser] = useState("");
    const [cabang, setCabang] = useState("");
    const [namaSpv, setNamaSpv] = useState("");
    const [jabatanSpv, setJabatanSpv] = useState("");
    const [role, setRole] = useState("");
    const [token, setToken] = useState("");
    const [expire, setExpire] = useState(""); 
    const [pinjaman, setPinjaman] = useState([]);
    const componentRef = React.useRef();
    const [dukcapil, setDukcapil] = useState("SESUAI");
    const [tanggal, setTanggal] = useState(null);
    const [loading, setLoading] = useState(true);
    const [enterHeader, setEnterHeader] = useState('0');
    const [enterKeterangan, setEnterKeterangan] = useState('0');
    const axiosJWT = axios.create();


const styleTitle = {
    fontSize: 22,
    color: "#4a54f1",
    textAlign: "center",
    paddingTop: "30px",
    paddingBottom: "30px",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)", // Menambahkan efek bayangan pada teks
    fontWeight: "bold", // Membuat teks menjadi tebal
    fontFamily: "Arial, sans-serif", // Mengubah jenis font menjadi Arial atau font lainnya
  };

  
  useEffect(() => {
        refreshToken();
      }, []);

useEffect(() => {
      if (token) {
        getUserById();
        getDebiturByid();
      }
    }, [token]);

  
axiosJWT.interceptors.request.use(async(config) => {
  const curretDate = new Date();
  if(expire * 1000 < curretDate.getTime()){
      const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
      config.headers.Authorization = `Bearer ${response.data.accessToken}`;
      setToken(response.data.accessToken);
      const decoded = jwt_decode(response.data.accessToken);
      setRole(decoded.role);
      // console.log("ini jwt: ",role);
      setExpire(decoded.exp);
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

const refreshToken = async() => {
try {
    const response = await axios.get(`${process.env.REACT_APP_MASTER_URL}/token`);
    setToken(response.data.accessToken);
    const decoded = jwt_decode(response.data.accessToken);
    setIdUser(decoded.userId);
    setCabang(decoded.cabang);
    setNamaLengkapUser(decoded.namaLengkap);
    setRole(decoded.role);
    setExpire(decoded.exp);

} catch (error) {
  if(error.response){
    toast.warning("Silahkan Login!");
    navigate("/login");
  }
}
}

const getUserById = async () => {
  try {
    const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/users/${idUser}`,{
        headers:{
            Authorization:`Bearer ${token}`
        }
    });
    setLoading(false)
    // toast.success("Data diload, Silahkan Export");
    setNamaSpv(response.data.spv_user.namaSpv);
    setJabatanSpv(response.data.spv_user.jabatan);
    
  } catch (error) {
    if(error.response){
      setLoading(false)
      toast.warning("Gagal Ambil Data Spv, Coba lagi..");
    }
  }
    
  }


const getDebiturByid = async () =>{
  try {
    const response = await axiosJWT.get(`${process.env.REACT_APP_MASTER_URL}/print/${idDebitur}`,{
      headers:{
          Authorization:`Bearer ${token}`
      }
    })
    const formattedDate = formatDate(response.data[0].createdAt);
    setPinjaman(response.data);
    setTanggal(formattedDate);
  }
  catch (error) {
    toast.warning("Gagal Ambil Data, Coba lagi..");
  }

}

const formatDate = (inputDate) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember"
  ];

  const date = new Date(inputDate);
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return `${day} ${months[monthIndex]} ${year}`;
};


  const columns = [
    {
      accessorKey: "cabangKet",
      header: "Cabang Ket",
    },
    {
      accessorKey: "bakiDebet",
      header: "Baki Debet",
    },
    {
      accessorKey: "tanggalMulai",
      header: "Tanggal Mulai",
    },
    {
      accessorKey: "tanggalJatuhTempo",
      header: "Tanggal Jatuh Tempo",
    },
  ];

  return (  
    <div>
      {loading ?
            <div style={stylespinner}>
                <PacmanLoader
                    color={'#301E67'}
                    loading={loading}
                    size={30}
                    textAlign='centered'
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
                </div> 
        :
    <div className="section is-fullheight" style={{ 
        backgroundColor: '#1b48f1', 
        height: '100vh',
        filterImage:'blur(50px)'}} >
    <div className='field' ></div>
      <div className="container ">
        <div className="column is-12">
          <div className="box" >
                <img src={`${process.env.REACT_APP_MASTER_URL2}/logonusamba.png`}  alt="Not Found" width={200} height={200}></img>
                <label className="label" style={styleTitle}>
                    <center>
                        DETAIL DEBITUR SLIK <br/> BPR BANK NUSAMBA JATIM <br/> CAB. {cabang?.toUpperCase()}
                    </center>
                </label>
                <div style={{display: "none"}} className="filed mb-2">
                            <label className="label">DUKCAPIL </label>
                            <div className="controls">
                                <input disabled type="text" style={{width:'500px'}} className="input" value={dukcapil} onChange={(e)=> setDukcapil(e.target.value)} placeholder="dukcapil"/>
                            </div>
                </div>
                <div className="filed mb-2">
                            <label className="label">TANGGAL SLIK</label>
                            <div className="controls">
                                <input type="text" style={{width:'500px'}} className="input" value={tanggal} onChange={(e)=> setTanggal(e.target.value)} placeholder="dd mm yyyy"/>
                            </div>
                </div>
                {/* <div className="filed mb-2">
                            <label className="label">ENTER Header</label>
                            <div className="controls">
                                <input type="number" style={{width:'300px'}} className="input" value={enterHeader} onChange={(e)=> setEnterHeader(e.target.value)} placeholder="Enter Konten"/>
                            </div>
                </div> */}
                {/* <div className="filed mb-2">
                            <label className="label">ENTER Keterangan</label>
                            <div className="controls">
                                <input type="number" style={{width:'300px'}} className="input" value={enterKeterangan} onChange={(e)=> setEnterKeterangan(e.target.value)} placeholder="Enter Konten"/>
                            </div>
                </div> */}
                   <div className="filed mb-2">
                            <label className="label">Cabang</label>
                            <div className="controls">
                                <input type="text" style={{width:'300px'}} className="input" value={cabang} onChange={(e)=> setCabang(e.target.value)} placeholder="Enter Konten"/>
                            </div>
                </div> 
                <center>
                  <button
                      type="button"
                      className="button is-success mr-2"
                      onClick={() => navigate("/", { replace: true })}
                    >
                      Kembali
                    </button>
                {/* <Link to={`/`} style={{ textDecoration: "none" }} className="button is-success mr-2">Kembali</Link> */}
                {/* <ReactToPrint
                  trigger={() => <button style={{ display: tanggal != null ? '' : 'none' }} className="button is-warning">Preview</button>}
                  content={() => componentRef.current}
                  pageStyle="@page { size: A4; margin: 0; } @media print { body { margin: 0; } }"
                  fileName="custom_name.pdf" 
                /> */}
                { tanggal && namaSpv && namaLengkapUser && (
                  <button className="button is-link ml-2" onClick={() => handleExportClickOld(namaSpv, jabatanSpv, namaLengkapUser, pinjaman, cabang, tanggal)}>Download Old</button>
                )}
                { tanggal && namaSpv && namaLengkapUser && (
                  <button className="button is-link ml-2" onClick={() => handleExportClick(namaSpv, jabatanSpv, namaLengkapUser, pinjaman, cabang, tanggal)}>Download New</button>
                )}

                <div style={{ display: "none" }}>
                  <FormCetak ref={componentRef} cabang={cabang} namaLengkapUser={namaLengkapUser} idDebitur={idDebitur} dukcapil={dukcapil} tanggal={tanggal} enterHeader={enterHeader} enterKeterangan={enterKeterangan} />
                </div>
                </center>
        </div>
    </div>
    </div>
    </div>
}
</div>
  );
}

export default DetailDebitur